import { render, staticRenderFns } from "./ProfilChangePassword.vue?vue&type=template&id=544c034e&"
import script from "./ProfilChangePassword.vue?vue&type=script&lang=js&"
export * from "./ProfilChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports